<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <h1>Booking details</h1>
        <v-row>
            <v-col cols="12" md="6">
                <v-card :loading="loading">
                    <v-card-text>
                        <v-simple-table>
                            <tbody>
                            <tr>
                                <th>Order</th>
                                <td>{{dados.id}}</td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>
                                    <v-select :items="dados.statusList" item-text="status_en" item-value="id" v-model="dados.status" @change="updateStatus">

                                    </v-select>
                                </td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{{dados.date}}</td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{{dados.customer}}</td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{{dados.email}}</td>
                            </tr>
                            <tr>
                                <th>Telephone</th>
                                <td>{{dados.telephone}}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card :loading="loading">
                    <v-card-text>
                        <v-simple-table>
                            <tbody>
                            <tr>
                                <th>House</th>
                                <td>{{dados.house}}</td>
                            </tr>
                            <tr>
                                <th>Check-in</th>
                                <td>{{dados.checkin}}</td>
                            </tr>
                            <tr>
                                <th>Check-out</th>
                                <td>{{dados.checkout}}</td>
                            </tr>
                            <tr>
                                <th>Guests</th>
                                <td>{{dados.guests}}</td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td>${{dados.total | number_format_real }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                valid:true,
                loading:true,
                erro:false,
                dados:{
                    id:this.$route.params.id,
                },
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Bookings',
                        disabled: false,
                        to: '/bookings',
                    },
                    {
                        text: 'Bookings Management',
                        disabled: true,
                        to: '/booking',
                    },
                ],
            }
        },
        methods: {
            updateStatus(){
                var arr = JSON.stringify(this.dados);
                this.$http.post("https://api.bestchoicevacation.com/orders/update",arr,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response => {
                    console.log(response.data);
                });
            }
        },
        mounted(){
            this.$http.get("https://api.bestchoicevacation.com/orders/"+this.$route.params.id,{
                headers: {
                    'x-access-token': localStorage.hash
                }
            }).then(response =>{
                this.loading = false;
                this.dados = response.data;
            });
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>